import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';
import QuorumBusiness from '@/dominio/QuorumBusiness';

export default class FiltroQuorumMinimo extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Quórum (quantidade mínima de integrantes da composição)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return QuorumBusiness.isObedeceQuorumComposicao(
            registro,
            this.store.rootStore.sessaoStore.sessaoSelecionada?.quorum
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
